import React from 'react'
import { Checkbox, ConfigProvider } from 'antd'
import styles from './CheckboxField.module.css'
import { Controller, useFormState } from 'react-hook-form'
import { toJS } from 'mobx'

const CheckboxRender = React.forwardRef(
  ({ onChange = () => {}, checked, fieldState, formState, ...props }, ref) => (
    <Checkbox
      {...props}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      ref={ref}
    />
  )
)

const ActiveCheckboxField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const input_style = field.input_design
    ? { ...field.input_design, height: 'fit-content' }
    : {}

  console.log('inpu_desing', toJS(input_style))

  // const hasErrors = () => {
  //   for (let index = 0; index < field.options.length; index++) {
  //     if (errors[`${field.idFieldCanvas}[${index}]`]) {
  //       return true
  //     }
  //   }
  //   return false
  // }

  // Fonction helper pour vérifier les erreurs
  const hasErrors = () => {
    return errors[field.idFieldCanvas] ? true : false
  }

  let containerClass = styles.checkbox__container
  if (isSubmitted) {
    containerClass += hasErrors() ? ' input-error' : ' input-success'
  }

  return (
    <div className={containerClass}>
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.idFieldCanvas}
        defaultValue={field.VALUE__reponse || []}
        render={({ field: { onChange, value }, ...props }) =>
          field.options.map((option, index) => (
            <CheckboxRender
              {...props}
              style={input_style}
              key={option.id}
              onChange={(checked) => {
                let newValue
                if (checked) {
                  newValue = [...value, option.value || option.label]
                } else {
                  newValue = value.filter(
                    (v) => v !== (option.value || option.label)
                  )
                }
                onChange(newValue)
              }}
              checked={value.includes(option.value || option.label)}
            >
              {option.label}
            </CheckboxRender>
          ))
        }
      />
    </div>
  )
}

const InactiveCheckboxField = ({ field }) => {
  const input_style = field.input_design
    ? { ...field.input_design, height: 'fit-content' }
    : {}

  return (
    <div className={styles.checkbox__container}>
      {field.options.map((option, index) => (
        <CheckboxRender key={index} style={input_style}>
          {option.label}
        </CheckboxRender>
      ))}
    </div>
  )
}

const config = {
  // Ajoutez ici vos personnalisations. Par exemple :
  // componentSize: 'small'
}

const CheckboxField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveCheckboxField field={field} control={control} />
  ) : (
    <InactiveCheckboxField field={field} />
  )
}

export default CheckboxField
